import { useState } from "react";

export const useToggle = (initialValue = false) => {
  const [toggle, setToggle] = useState(initialValue);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  const handleValueToggle = (value) => {
    setToggle(value);
  };
  return [toggle, handleToggle, handleValueToggle];
};
